import { Button, Typography } from "@foodpilot/foods";

type TextActionProps = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
};

export const TextAction = ({ label, onClick, disabled = false }: TextActionProps) => (
    <Button
        variant="text"
        size="small"
        onClick={onClick}
        disabled={disabled}
        sx={{ alignSelf: "flex-start", minWidth: "auto", height: "auto", padding: 0, textDecoration: "underline" }}
    >
        <Typography variant="small-medium">{label}</Typography>
    </Button>
);
